export default __webpack_public_path__ + "static/media/7-min.2d39c1e6.jpg";